import {create} from "zustand";

import {
  makeWeatherMapFromSchedule,
  mapGismeteoFact,
  mapGismeteoToDays,
  mapGismeteoToSchedule,
} from "../lib/weatherMapper";
import {GismeteoForecastResponse, WeatherState} from "./types";
import {$api} from "shared/api";

export const useWeatherStore = create<WeatherState>()((set, get) => ({
  scheduleRows: [],
  factForecast: undefined,
  forecastDays: [],
  forecastDaysHours: [],
  weatherMapCalendar: {},
  error: undefined,
  lastUpdated: undefined,
  coords: null,
  activeDayIso: undefined,

  setCoords: (c) => set({ coords: c }),
  setActiveDay: (iso) => set({ activeDayIso: iso }),

  fetchForecast: async ({ lat, lon }) => {
    const safeLat = Math.abs(Number(lat)) <= 90 ? Number(lat) : 10;
    const safeLon = Math.abs(Number(lon)) <= 180 ? Number(lon) : 10;

    try {
      async function fetchForecastApi(lat: number, lon: number) {
        return $api.get(`/collector/weather/forecast/h1`, {
          params: {
            lat,
            lon,
            days: 35,
          },
          baseURL: "",
        });
      }
      const { data } = await fetchForecastApi(safeLat, safeLon);

      const res = data as GismeteoForecastResponse;

      const scheduleRows = mapGismeteoToSchedule(res);
      const factForecast = mapGismeteoFact(res);
      const forecastDays = mapGismeteoToDays(res);
      const weatherMapCalendar = makeWeatherMapFromSchedule(forecastDays);

      set({
        scheduleRows,
        factForecast,
        forecastDays,
        weatherMapCalendar,

        error: undefined,
        lastUpdated: Date.now(),
      });
    } catch (e: any) {
      set({
        error: e?.message ?? "Не удалось получить прогноз",
      });
    }
  },

  refreshForecast: () => {
    const { coords, fetchForecast } = get();
    if (coords) {
      fetchForecast(coords);
    }
  },
}));
